import React, { useEffect } from "react"
import styled from "styled-components"
import Colors from "../../theme/Colors"
import { notPhone, OnPhone } from "../../theme/MediaQueries"
import { WidgetSubTitleText, WidgetTitleText } from "../../theme/Typography"

const Container = styled.div`
  ${notPhone} {
    box-shadow: 0 4px 8px 2px rgba(0, 0, 0, 0.23);
  }
`

const AddonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
`

const WidgetTitleContainer = styled.div`
  background-color: ${Colors.blue};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 8px 16px 16px 8px;
  ${notPhone} {
    padding: 16px 0;
    width: 100%;
  }
`
const WidgetTitle = styled.div`
  ${WidgetTitleText};
`
const WidgetSubtitle = styled.div`
  ${WidgetSubTitleText};
`

const ArrowDown = styled.div`
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 10px solid ${Colors.blue};
`

const WidgetAttributes = {
  id: "ffg-widget",
  "data-hero": true,
  src: `${process.env.WIDGET_URL}/BankForm.js`,
}

const Widget = ({ text }) => {
  useEffect(() => {
    const el = document.getElementById("widget-container")
    const widgetScript = document.createElement("script")
    Object.entries(WidgetAttributes).forEach(([attr, value]) =>
      widgetScript.setAttribute(attr, value)
    )
    el.appendChild(widgetScript)
  }, [])

  return (
    <Container>
      <AddonContainer>
        <WidgetTitleContainer>
          <WidgetTitle>Kreditvergleich</WidgetTitle>
          {text && (
            <OnPhone>
              <WidgetSubtitle>{text}</WidgetSubtitle>
            </OnPhone>
          )}
        </WidgetTitleContainer>
        <ArrowDown />
      </AddonContainer>

      <div id="widget-container" />
    </Container>
  )
}
Widget.propTypes = {}

Widget.defaultProps = {}

export default Widget
